'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'planet-ringed';
var width = 576;
var height = 512;
var aliases = [129680];
var unicode = 'e020';
var svgPathData = 'M480.9 93.2c14-23.7 22.9-43.1 27.5-57.5-13.7 4.4-31.9 12.6-54.1 25.5-13.6-11.6-28.1-21.6-43.3-29.9 5.2-3.3 10.4-6.5 15.5-9.5 30-17.7 56.5-29.7 78-34.9 6.7-1.6 13.9-3.1 20.7-3.1 6.5-.1 17.1 1.1 25.6 9.6s9.6 19 9.6 25.6c-.1 6.7-1.5 13.9-3.1 20.7-5.2 21.4-17.2 48-34.9 78-11.4 19.2-25.1 39.8-40.8 61.3 9.5 23.8 14.7 49.8 14.7 77.1 0 114.9-93.1 208-208 208-27.2 0-53.2-5.2-77.1-14.7-21.5 15.8-42.1 29.5-61.3 40.8-30 17.7-56.5 29.7-78 34.9-6.7 1.6-13.9 3.1-20.7 3.1-6.5 .1-17.1-1.1-25.6-9.6S16 499.5 16 493c.1-6.7 1.5-13.9 3.1-20.7 5.2-21.4 17.2-48 34.9-78 3-5.1 6.1-10.2 9.5-15.5 8.3 15.2 18.3 29.7 29.9 43.3-12.9 22.2-21.1 40.4-25.5 54.1 14.4-4.6 33.7-13.5 57.5-27.5 12.4-7.4 25.6-15.8 39.3-25.4-51.3-37.9-84.5-98.8-84.5-167.4 0-114.9 93.1-208 208-208 68.6 0 129.5 33.3 167.4 84.5 9.5-13.7 18-26.9 25.4-39.3zm-55.6 80.4c-28-46.5-78.9-77.5-137.1-77.5-88.4 0-160 71.6-160 160 0 58.2 31.1 109.1 77.5 137.1 36.9-28.8 76.5-63.7 116.2-103.4s74.6-79.3 103.4-116.2zM257.6 413.1c9.9 1.9 20.1 2.9 30.6 2.9 88.4 0 160-71.6 160-160 0-10.5-1-20.7-2.9-30.6-26.3 32-56.4 65.2-89.4 98.2s-66.2 63.1-98.2 89.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlanetRinged = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;